import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { MailChimpSubscriptionApi } from "store/slices/salonSlice";
import { usermoduleListViewApi } from "../store/slices/usermoduleSlice";
import { OpenAddClientForm } from "../store/slices/clientSlice";
import { notificationCountApi } from "store/slices/notificationSlice";
import { OpenSmsRunOutAlerts } from "store/slices/calendarSlice";
import { useAuth } from "context/authContext";

// Module-level guards so remounting pages/drawers that call SalonModule()
// do not re-fire global bootstrap APIs on every open.
let authUserFetched = false;
let notificationCountFetched = false;
let mailchimpFetchedForSalon = null;
let smsAlertChecked = false;

const SalonModule = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { getAuthUser } = useAuth();
  const usermodule = useSelector((state) => state.usermodule.isListView);
  const auth = useSelector((state) => state.auth);
  const currentUser = auth && auth.user;
  const navigate = useNavigate();
  const authRef = useRef(auth);
  authRef.current = auth;

  useEffect(() => {
    if (authUserFetched) return;
    authUserFetched = true;
    const fetchAuthUser = async () => {
      try {
        const userData = await getAuthUser();
        if (userData) {
          const latestAuth = authRef.current;
          dispatch({
            type: "auth/user",
            payload: {
              ...latestAuth,
              user: {
                ...latestAuth.user,
                ...userData,
              },
            },
          });
        }
      } catch (error) {
        authUserFetched = false;
        console.error("Error fetching auth user:", error);
      }
    };
    fetchAuthUser();
  }, [dispatch, getAuthUser]);

  if (currentUser && currentUser.role_id == 8 && ["/dashboard", "/staff", "/reports"].includes(location && location.pathname)) {
    navigate("/noaccess");
  }

  useEffect(() => {
    if (usermodule.length === 0) {
      dispatch(usermoduleListViewApi());
      dispatch(usermoduleListViewApi({ type: "staff_access" }));
    }
    if (!notificationCountFetched) {
      notificationCountFetched = true;
      dispatch(notificationCountApi());
    }
  }, [dispatch, location.pathname, usermodule.length]);

  useEffect(() => {
    dispatch(OpenAddClientForm(""));
    const salonId = currentUser && currentUser.salon && currentUser.salon.id ? currentUser.salon.id : "";
    if (salonId && mailchimpFetchedForSalon !== salonId) {
      mailchimpFetchedForSalon = salonId;
      dispatch(MailChimpSubscriptionApi({ id: salonId, salon_id: salonId }));
    }
  }, [dispatch, location.pathname, currentUser && currentUser.salon && currentUser.salon.id]);

  useEffect(() => {
    if (smsAlertChecked) return;
    smsAlertChecked = true;
    if (currentUser && currentUser.salon && currentUser.salon.is_empty_sms_alert == 1) {
      dispatch(OpenSmsRunOutAlerts("open"));
    }
  }, [dispatch, currentUser]);
};

export { SalonModule };
